/* Atlas V3 Desktop — The Cycle (AI cycle & supply-chain brain).
   Renders the shared CycleContent (src/v2/v3/Cycle) in desktop document flow —
   same data (useCyclePanel), world dot-map, signals, and detail sheet as the
   mobile screen. openTicker comes from the desktop TickerPanelProvider via
   TickerCtx (useTicker), so signal-cell interactions still open the dock. */
import { CycleContent } from '@/v2/v3/Cycle'

export function Cycle() {
  return <CycleContent desktop />
}
